module.exports = __webpack_public_path__ + "img/mehtap.4771bb24.jpg";